import React, { ButtonHTMLAttributes, memo } from 'react'
import { ThreeDotsLoader } from '../../assets/icons/ThreeDotsLoader'
import {
  ButtonThemesType,
  BUTTON_STYLE_PRIMARY
} from '../../libraries/ButtonTheme'
import { TooltipPositionTypes } from '../../libraries/Tooltips'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './Button.scss'
const rootClassName = 'component-button'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  'tooltip-position'?: TooltipPositionTypes
  'tooltip-text'?: string
  onClick?: (evt?: any) => void
  theme?: ButtonThemesType
  disabled?: boolean
  w100?: boolean
  leftIcon?: React.ReactNode | object
  rightIcon?: React.ReactNode | object // rightIcon?:// PropTypes.object,
  mobileBottomPage?: boolean
  loader?: {
    loading: boolean
    loaderTheme: string
    loaderSize: number
  }
  children?: React.ReactNode
}

function Button(props: ButtonProps) {
  const handleClick = (evt: any) => {
    if (
      typeof props.onClick === 'function' &&
      !props.disabled &&
      (!props.loader || !props.loader.loading)
    ) {
      props.onClick(evt)
    }
  }

  const getProps = () => {
    const p = {
      ...props,
      onClick: handleClick,
      className: getMergedClassNames([
        'nunito',
        rootClassName,
        props.className,
        `${rootClassName}-${props.theme}`,
        props.w100 ? `${rootClassName}-w100` : '',
        props.mobileBottomPage ? `${rootClassName}-bottom-mobile` : ''
      ])
    }
    delete p.mobileBottomPage
    delete p.children
    delete p.theme
    delete p.w100
    delete p.leftIcon
    delete p.rightIcon
    delete p.loader
    return p
  }

  return (
    <button {...getProps()}>
      {props.leftIcon && (
        <div
          className={getMergedClassNames([
            `${rootClassName}-icon`,
            `${rootClassName}-left-icon`,
            props.loader && props.loader.loading ? `${rootClassName}-hide` : ''
          ])}
        >
          {props.leftIcon}
        </div>
      )}
      <div
        className={`${rootClassName}-label nunito ${
          props.loader && props.loader.loading ? `${rootClassName}-hide` : ''
        }`}
      >
        {props.children}
      </div>
      {props.rightIcon && (
        <div
          className={getMergedClassNames([
            `${rootClassName}-icon`,
            `${rootClassName}-right-icon`,
            props.loader && props.loader.loading ? `${rootClassName}-hide` : ''
          ])}
        >
          {props.rightIcon}
        </div>
      )}
      {props.loader && props.loader.loading ? (
        <div className={`${rootClassName}-loader`}>
          <ThreeDotsLoader
            theme={props.loader.loaderTheme ? props.loader.loaderTheme : null}
            size={props.loader.loaderSize ? props.loader.loaderSize : null}
          />
        </div>
      ) : undefined}
    </button>
  )
}

Button.defaultProps = {
  onClick: () => {},
  theme: BUTTON_STYLE_PRIMARY,
  disabled: false,
  w100: false,
  leftIcon: undefined,
  rightIcon: undefined,
  mobileBottomPage: false,
  loader: {
    loading: false,
    loaderTheme: 'secondary',
    loaderSize: 2
  }
}

export default memo(Button)
